export const stateSubsidiesRouter = [
  {
    path: '/stateSubsidies',
    name: 'stateSubsidies',
    component: () => import('@/views/stateSubsidies'),
    meta: {
      title: '商品补贴'
    }
  },
  {
    path: '/stateSubsidies/goodsDetails',
    name: 'stateSubsidiesGoodsDetails',
    component: () => import('@/views/stateSubsidies/goodsDetails'),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/stateSubsidies/selectStore',
    name: 'stateSubsidiesSelectStore',
    component: () => import('@/views/stateSubsidies/selectStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/stateSubsidies/search',
    name: 'stateSubsidiesSearch',
    component: () => import('@/views/stateSubsidies/search'),
    meta: {
      title: '订单搜索'
    }
  },
  {
    path: '/stateSubsidies/informationReporting',
    name: 'stateSubsidiesInformationReporting',
    component: () => import('@/views/stateSubsidies/informationReporting'),
    meta: {
      title: '信息上报'
    }
  }
]
